import AppRoutes from "routes/AppRoute";

function App() {
  return <AppRoutes />;
}

export default App;
